import React from 'react';
import { useDraggable } from '@dnd-kit/core';

interface DraggableItemProps {
    id: string;
    label: string;
    type: 'TEXT' | 'PRODUCT' | 'FILE' | 'COLOR' | 'EXTERNAL_IMAGE';
    icon?: React.ReactNode;
    style?: React.CSSProperties;
    value?: string;
}

const _DraggableItem: React.FC<DraggableItemProps> = ({ id, label, type, icon, style, value }) => {
    const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
        id,
        data: {
            type: 'new-item',
            itemType: type,
            style: style || {},
            colorValue: type === 'COLOR' ? value : undefined,
        },
    });

    const combinedStyle = {
        transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
        zIndex: 1000,
        cursor: 'grab',
        opacity: isDragging ? 0.8 : 1,
        userSelect: 'none',
        ...style, 
    } as React.CSSProperties;

    if (type === 'COLOR') {
        return (
            <div
                ref={setNodeRef}
                {...listeners}
                {...attributes}
                style={combinedStyle}
                className="color-swatch"
            />
        );
    }

    return (
        <div
            ref={setNodeRef}
            style={combinedStyle}
            className={`position-relative p-1 ${isDragging ? 'invisible' : ''}`}
        >
            <div
                className="d-flex align-items-center gap-2 p-2 border rounded bg-light w-100 cursor-grab active:cursor-grabbing"
                {...listeners}
                {...attributes}
                style={{ userSelect: 'none' }}
            >
                <div>{icon}</div>
                <div className="flex-grow-1">{label}</div>
            </div>
        </div>
    );
};

export default _DraggableItem;
